<script lang="ts">
	import { World } from '../../game/World';
	import { currentLevel, currentLevelWin } from '../../stores/current-level';
	import CodeArea from './CodeArea.svelte';
	import TabCardSet from '../elements/TabCardSet.svelte';
	import TabCard from '../elements/TabCard.svelte';
	import WorldView from './WorldView.svelte';
	import MainMenu from '../menu/MainMenu.svelte';
	import WinScreen from './WinScreen.svelte';
	import LoseScreen from './LoseScreen.svelte';
	import { urlFragment } from '../../stores/url-fragment';

	const world = new World();
	$: world.startLevel( $currentLevel );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			urlFragment.setUrlKey( 'tab', $urlFragment.tab === 'menu' ? undefined : 'menu' );
		}
	} );
</script>

<div class="play-screen">
	<div class="left-column">
		<CodeArea { world } locked={ $currentLevelWin } />
	</div>

	<div class="right-column">
		<WorldView { world } />

		<TabCardSet>
			<TabCard id="menu" title="Menu" icon="star">
				<MainMenu />
			</TabCard>
		</TabCardSet>
	</div>

	{#if $currentLevelWin}
		{#if $currentLevelWin.win}
			<WinScreen />
		{:else}
			<LoseScreen />
		{/if}
	{/if}
</div>

<style>
	.play-screen {
		position: absolute;
		width: 100%; height: 100%;
		top: 0px; left: 0px;
		display: flex;
	}

	.left-column {
		width: 30%; height: 100%;
		min-width: 320px;
	}

	.right-column {
		width: 80%; height: 100%;
		overflow: hidden;
		position: relative;
	}
</style>